module.exports = __webpack_public_path__ + "static/media/Leana_Neparidze_Resume.6d229632.pdf";